/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_ApikeysInputs */

const en_landing_chips_apikeys = /** @type {(inputs: Landing_Chips_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

const zh_landing_chips_apikeys = /** @type {(inputs: Landing_Chips_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Landing_Chips_ApikeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_apikeys = /** @type {((inputs?: Landing_Chips_ApikeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_ApikeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_apikeys(inputs)
	return zh_landing_chips_apikeys(inputs)
});
export { landing_chips_apikeys as "landing.chips.apikeys" }